module.exports = __webpack_public_path__ + "img/UserCircle.de60955c.png";